module.exports = __webpack_public_path__ + "img/c9.36d279e6.png";